import { createFileRoute } from "@tanstack/react-router";

import { GuidePage } from "@/features/guide/guide-page";

/**
 * 共創プラットフォームの使い方。アカウントを持たない人にも見せるため認証ガードは付けない。
 * 表示内容は `features/guide/steps.ts` の固定データと `public/case/showroom-ai/` の画像で、
 * DB / API は参照しない。
 */
export const Route = createFileRoute("/guide")({
  component: GuidePage,
});
